import { Text as ChakraText, TextProps } from "@chakra-ui/react";

interface PropTypes extends TextProps {
    type?: "heading" | "subHeading" | "normal";
    children?: React.ReactNode;
    /** @deprecated No longer used. Kept so existing stories keep compiling. */
    isStorybook?: boolean;
}

const Text = ({
    type = "normal",
    children,
    // Pulled out so it is not forwarded to the Chakra component.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isStorybook,
    ...textProps
}: PropTypes) => {
    const tp = { ...textProps };
    tp.color = tp.color ?? "gray.800";
    switch (type) {
        case "heading":
            tp.fontFamily = "komu, sans-serif";
            tp.fontSize = tp.fontSize ?? [32, 40];
            tp.lineHeight = tp.lineHeight ?? ["35px", "41px"];
            tp.textTransform = "none";
            break;
        case "subHeading":
            tp.fontFamily = tp.fontFamily ?? "infini, sans-serif";
            tp.fontWeight = "bold";
            tp.lineHeight = tp.lineHeight ?? ["24px", "30px"];
            tp.fontSize = tp.fontSize ?? [14, 16];
            break;
        case "normal":
            tp.fontFamily = tp.fontFamily ?? "inter, sans-serif";
            tp.lineHeight = tp.lineHeight ?? "30px";
            tp.fontSize = tp.fontSize ?? [14, 16];
    }

    return <ChakraText {...tp}>{children}</ChakraText>;
};

export default Text;
